import { Account } from '@/client/accounts';
import { SystemRoles, User } from '@/client/users';
import { branchAdminCheck } from '@/utils/helpers/account.helper';
import { isDemoRestrictedMode } from '@/utils/helpers/env.helper';

const BANNER_ROLES = [SystemRoles.ADMIN, SystemRoles.MULTIPLE_ACCOUNTS_ADMIN];

export const canSeeAddUsersBanner = (
  user: User | null,
  account: Account | null,
): boolean =>
  !!user &&
  !!account &&
  BANNER_ROLES.includes(user.role?.code as SystemRoles) &&
  !account.isSystem &&
  !!account.active &&
  !isDemoRestrictedMode(account, user) &&
  !user.meta?.addUsersBannerDismissedAt;

export const canSetUpIntegrationFromBanner = (
  user: User | null,
  account: Account | null,
): boolean => !branchAdminCheck(user, account);
